module.exports = __webpack_public_path__ + "static/media/4.749a42d6.png";